// extracted by mini-css-extract-plugin
export var clickTrap = "click-trap-module--clickTrap--9e175";